import React from 'react';
import { Button } from '@mui/material';
import { Add } from '@mui/icons-material';
import { Link as ButtonLink, useNavigate } from 'react-router-dom';
import { useModal } from 'mui-modal-provider';

import SecuredTitleIcon from '../../SecuredTitleIcon';
import { loginPath, newPostPath } from '../../../../Utils/routes';
import { PostTypes } from '../../../../Utils/Types';
import { Space } from '../../../../Utils/Types/Space';
import { Post } from '../../../../Utils/Types/Posts';
import ContributionLabel from './ContributionLabel';
import EntitySubscriptionModal from '../../../EntitySubscriptionModal';
import useCurrentUser from '../../../../Hooks/useCurrentUser';

interface ContributionButtonProps {
  post: Post;
  space: Space;
  postComing: boolean;
  isResponsive?: boolean;
}

export default function ContributionButton({
  post,
  space,
  postComing,
  isResponsive,
}: ContributionButtonProps) {
  const { isLoggedIn } = useCurrentUser();
  const navigate = useNavigate();
  const { showModal } = useModal();

  const postFormPath = newPostPath(space.slug, PostTypes.IDEA, { parent_id: post.id });

  const handleCreateIdeaClick = (e: any) => {
    e.preventDefault();
    if (!isLoggedIn) {
      navigate(loginPath());
    } else {
      if (!space.entity_subscription) {
        showModal(EntitySubscriptionModal);
      } else {
        navigate(postFormPath);
      }
    }
    return false;
  };

  return (
    <>
      <SecuredTitleIcon post={post} />

      <Button
        color="primary"
        size="large"
        variant="contained"
        disabled={postComing}
        startIcon={<Add />}
        data-testid="add-or-see-idea-button"
        to={postFormPath}
        component={ButtonLink}
        onClick={handleCreateIdeaClick}
        fullWidth={isResponsive}
      >
        <ContributionLabel
          contributionKind={post.config?.contribution_kind}
          contributionKindLabel={post.config?.contribution_kind_label}
        />
      </Button>
    </>
  );
}
